import React from 'react'
import PropTypes from 'prop-types'

import { LoadingWave } from '../../components'
import { sleep } from '../../utils'

export default class CanvasExternalTools extends React.Component {
  static propTypes = {
    onCreateTools: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
    tools: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    checkingCourse: true,
    error: false,
  }

  _checkTools = async () => {
    await Promise.all([
      this.props.refresh(),
      sleep(1500), // to let the user read the changes
    ]).then(() => this.setState({ checkingCourse: false }))

    const { course_link: courseLink } = this.props.tools

    if (!courseLink) {
      await Promise.all([
        this.props.onCreateTools(),
        sleep(1500), // to let the user read the changes
      ]).then(this.props.onFinish, () => {
        this.setState({ loading: false, error: true })
      })
    } else {
      this.props.onFinish()
    }
  }

  componentDidMount() {
    this._checkTools()
  }

  render() {
    return (
      <div className={`maxw-600px mx-auto text-center`}>
        {this.state.error ? (
          <div className="card border-danger">
            <div className="card-body">
              <div>
                <i className="text-danger fa-2x fal fa-exclamation-triangle " />
              </div>
              <p>
                We were unable to automatically configure the external tool
                connection to your course. The external tool can be installed
                manually from the EduAppCenter:{' '}
              </p>
              <p>
                MyEducator Smart Textbook:{' '}
                <a href="https://www.eduappcenter.com/apps/1064">
                  https://www.eduappcenter.com/apps/1064
                </a>
              </p>
              <p>
                If you are still unable to install the external tool, reach out
                to your organization&apos;s Canvas admins for additional
                support.{' '}
              </p>
              <p>
                Once the MyEducator Smart Textbook external tool has been
                installed, you can return here to finalize the setup.
              </p>
            </div>
          </div>
        ) : (
          <React.Fragment>
            <h4>
              {this.state.checkingCourse
                ? 'Checking Course...'
                : 'Creating Course Link...'}
            </h4>
            {this.state.loading ? <LoadingWave /> : null}
          </React.Fragment>
        )}
      </div>
    )
  }
}
